import { useEffect, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { Button, formatTabTitle } from "../../../ds";
import { IdentityService } from "../../../lib/infrastructure/identity/IdentityService";
import { FullScreenFrame } from "../../../modules/system/FullScreenFrame";

/** Shell-SessionExpired: "Session expired", Sign in (back to where the user was), Go to the home page. */
export function SessionExpiredPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Where the user was when the session died. Absent, the literal "null" (what an un-guarded
  // template produces), or the expired page itself all fall back to the root — otherwise sign-in
  // would return them to a path that does not exist.
  const returnUrl = useMemo(() => {
    const url = searchParams.get("url");
    return url && url !== "null" && !url.includes("expired") ? url : "/";
  }, [searchParams]);

  useEffect(() => {
    document.title = formatTabTitle("Session expired");
  }, []);

  const signIn = (url: string) => {
    // Wipes the (possibly stale) MSAL cache but keeps the sign-in hints, so the address
    // comes back pre-filled and the provider is already known.
    IdentityService.clearIdentityStorage();
    navigate(`/identity/login?url=${encodeURIComponent(url)}`);
  };

  return (
    <FullScreenFrame title="Session expired" role="main">
      <p>Sign in again to return to where you were.</p>
      <div className="ark-fullscreen-actions">
        <Button text="Sign in" type="primary" onClick={() => signIn(returnUrl)} />
        <Button text="Go to the home page" type="white" onClick={() => signIn("/spaces")} />
      </div>
      {returnUrl !== "/" ? <p className="ark-fullscreen-note">You were on Ark · <span className="ark-mono">{returnUrl}</span></p> : null}
    </FullScreenFrame>
  );
}
